import React, { useEffect } from 'react';

import { Link, useLocation } from 'react-router-dom';
import classNames from 'classnames';
import { Button, Logo } from '@ergeon/core-components';
import { ThemeSwitch } from '@ergeon/help-components';
import { Bars3Icon } from '@ergeon/icons/hero/micro';

import PaletteTrigger from 'components/wiki/PaletteTrigger';

import MobileMenu from './MobileMenu';
import PhoneLink from './PhoneLink';
import { useMobileMenu } from './useMobileMenu';
import { TopPanelProps } from './types';

const TITLE_CLASSES = classNames(
  'shrink-0 whitespace-nowrap rounded-md heading-5 text-gray-900 dark:text-white',
  'focus:outline-hidden focus-visible:ring-2 focus-visible:ring-blue-500 dark:focus-visible:ring-blue-300',
);

const TopPanel: React.FC<TopPanelProps> = ({ ergeonUrl, isLoggedIn }) => {
  const { isOpen, open, close } = useMobileMenu();
  const { pathname, search } = useLocation();

  useEffect(function closeTheMenuAfterNavigating() {
    close();
  }, [close, pathname, search]);

  return (
    <>
      <header className="sticky top-0 z-30 border-b border-gray-200 bg-white dark:border-gray-800 dark:bg-gray-900">
        <div className="flex h-16 items-center gap-3 px-4 md:gap-8 md:px-6">
          <div className="flex min-w-0 items-center gap-3 md:gap-4">
            <Logo href={ergeonUrl} size="medium" />
            <span aria-hidden="true" className="h-6 w-px shrink-0 bg-gray-300 dark:bg-gray-700" />
            <Link className={TITLE_CLASSES} to="/help">
              Company Wiki
            </Link>
          </div>
          <div className="flex min-w-0 flex-auto items-center justify-end gap-3 md:gap-4">
            {isLoggedIn && <PaletteTrigger className="md:max-w-md md:flex-1" />}
            <div className="flex shrink-0 items-center gap-2 md:ml-auto">
              <PhoneLink className="hidden xl:inline-flex" />
              <ThemeSwitch className="max-md:hidden md:flex" />
              <Button
                aria-expanded={isOpen}
                aria-label="Open menu"
                className="lg:hidden"
                flavor="regular"
                isSquare
                onClick={open}
                taste="boundless">
                <Bars3Icon aria-hidden="true" className="size-6" />
              </Button>
            </div>
          </div>
        </div>
      </header>
      <MobileMenu isLoggedIn={isLoggedIn} isOpen={isOpen} onClose={close} />
    </>
  );
};

export default TopPanel;
